import { useQuery } from '../../../hooks';

import * as adminService from '../service';
import { AdminCacheKeys } from '../consts';
import { IPaginationParams } from '../../common';

export const useCustomerReports = (params?: Partial<IPaginationParams>) => {
  const getCustomerReports = useQuery({
    queryFn: async () => adminService.getCustomerReports(params),
    queryKey: [AdminCacheKeys.GetCustomerReports, params],
  });

  return {
    getCustomerReports,
  };
};
